'use strict';

angular.module('accessRequestModule')
    .controller('AccessRequestsCtrl', function ($scope, kdAccess, $http, model, roles, actions, DS) {

        const init = function () {
            $scope.model = model;
            $scope.roles = roles;
            $scope.actions = actions;
            $scope.kdAccess = kdAccess;
            $scope.selectedStatus = model.status;
            $scope.admin_rationale = model.admin_rationale;
            $scope.selectedRole = model.user && model.user.role ? model.user.role : {};

            $scope.roles.unshift({
                id: 0,
                name: '- Choose role -'
            });
        }


        $scope.setSelectedStatus = function (value) {
            $scope.selectedStatus = value;
        }

        $scope.setSelectedRole = function (role) {
            $scope.selectedRole = role;
        };

        this.saveModel = function () {
            const data = {
                status: $scope.selectedStatus,
                role_id: $scope.selectedRole.id,
                permissions: $scope.model.actions,
                admin_rationale: $scope.model.admin_rationale,
            }

            $http.put(DS.defaults.basePath + 'access-requests/' + model.id, data).then($scope.$close);
        };

        init();
    });
